import { mergeClasses } from '@fluentui/react-components';
import React from 'react';
import { useSegmentedBarStyles } from './SegmentedBar.styles';

export interface SegmentedBarSegment {
    key?: React.Key;
    node: React.ReactNode;
}

export interface SegmentedBarProps {
    className?: string;
    segments?: SegmentedBarSegment[];
}

const SegmentedBar = ({ className, segments }: SegmentedBarProps) => {
    const styles = useSegmentedBarStyles();

    return (
        <div className={mergeClasses(styles.root, className)}>
            {segments?.map((x) => {
                return (
                    <div className={styles.group} key={x.key}>
                        {x.node}
                    </div>
                );
            })}
        </div>
    );
};

export default SegmentedBar;
